module.exports = __webpack_public_path__ + "static/media/clock.94b57d1c.svg";